var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.lastMessage?.supportId === null)?_c('v-btn',{staticClass:"white--text mr-2",attrs:{"disabled":_vm.loading,"loading":_vm.gptResponseLoading,"color":"blue","depressed":"","fab":"","small":""},on:{"click":_vm.getGptResponse}},[_c('v-icon',[_vm._v("mdi-assistant")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }